<script setup>
const props = defineProps({
  name: {
    type: String,
    default: undefined,
  },
  departureName: {
    type: String,
    default: undefined,
  },
  arrivalName: {
    type: String,
    default: undefined,
  },

  withBack: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'back']);

const showStations = computed(() => props.departureName || props.arrivalName);
</script>

<template>
  <div class="forms-search-header">
    <button
      v-if="withBack"
      type="button"
      class="forms-search-header__button forms-search-header__button--back"
      aria-label="Back"
      @click="emit('back')"
    >
      <CIcon class="forms-search-header__icon" name="chevron-navigation" />
    </button>

    <div class="forms-search-header__name">
      <span class="forms-search-header__font forms-search-header__font--name">
        {{ name }}
      </span>
    </div>

    <div class="forms-search-header__wrapper">
      <div v-if="showStations" class="forms-search-header__stations">
        <div
          class="forms-search-header__station"
          :class="{
            'forms-search-header__station--empty': !departureName,
          }"
        >
          <span
            class="forms-search-header__font forms-search-header__font--station"
          >
            {{ departureName || $t('form.departureUnknown') }}
          </span>
        </div>

        <div
          class="forms-search-header__station"
          :class="{
            'forms-search-header__station--empty': !arrivalName,
          }"
        >
          <span
            class="forms-search-header__font forms-search-header__font--station"
          >
            {{ arrivalName || $t('form.arrivalUnknown') }}
          </span>
        </div>
      </div>

      <button
        type="button"
        class="forms-search-header__button"
        aria-label="Close"
        @click="emit('close')"
      >
        <CIcon class="forms-search-header__icon" name="cross" />
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.forms-search-header {
  display: flex;
  align-items: center;

  &__font {
    &--name {
      font-size: em(24);
      font-weight: 500;
      line-height: math.div(28, 24);
    }

    &--station {
      font-size: em(12);
      font-weight: 400;
      line-height: math.div(8, 12);
    }
  }

  &__icon {
    @include box(em(28));

    flex-shrink: 0;
    color: $color-main-1;
  }

  &__button {
    &--back {
      margin-right: em(8);
    }
  }

  &__name {
    color: $color-text;
  }

  &__wrapper {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  &__stations {
    margin-right: em(16);
    text-align: right;
  }

  &__station {
    color: $color-gray-4;

    &--empty {
      color: $color-gray-3;
    }
  }
}
</style>
